
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jetson-one",
      function () {
        return require("private-next-pages/jetson-one.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jetson-one"])
      });
    }
  